module.exports = __webpack_public_path__ + "5692da9295327c5dce8126d1d674d13c.svg";